import styled from '@emotion/styled';

export const Wrapper = styled.div`
  background-color: white;
  position: relative;

  img {
    max-width: 80vw;
    max-height: 70vh;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  max-width: 300px;
  margin: auto;
`;

export const StyledErrorText = styled.p`
  font-weight: 600;
  color: ${(props) => props.theme.color.red.default};
  text-align: center;
  margin: auto;
  width: 100%;
  font-size: 16px;
  padding: 10px 0px;
`;
